<!--
 * @Descripttion: 
 * @version: v1
 * @Author: liukx
 * @Date: 2022-05-01 23:09:12
 * @LastEditors: ???
 * @LastEditTime: 2022-05-11 22:33:54
-->
<template>
  <div class="wrapper">
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="visible"
      width="30%"
      @close="close"
    >
      <el-form
        :model="form"
        ref="form"
        :rules="validatorRules"
        size="small"
        label-width="80px"
      >
        <el-form-item label="角色名称" prop="name">
          <el-input v-model="form.name" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="角色描述">
          <el-input
            v-model="form.description"
            type="textarea"
            show-word-limit
            maxlength="200"
            :autosize="{ minRows: 4, maxRows: 6 }"
          ></el-input>
        </el-form-item>
        <el-form-item label="菜单权限" required>
          <div class="menuBar">
            <el-tree
              :data="menuTreeData"
              show-checkbox
              node-key="id"
              default-expand-all
              ref="ref_menuTree"
              :props="defaultProps_menu"
            >
            </el-tree>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">取 消</el-button>
        <el-button size="small" type="primary" @click="handleOk"
          >保 存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { httpAction } from '@/api/manage';
import { listMixin } from '@/mixins/listMixin';
import { getUserRoutes, getRoleAuthInfo, getUserRoutes2 } from '@/api/user';

export default {
  components: {},
  mixins: [listMixin],
  props: {},
  data() {
    return {
      defaultProps_menu: {
        children: 'childers',
        label: 'name',
      },
      menuTreeData: [],
      disableMixinCreated: true,
      options: [
        { label: '普通用户', value: 0 },
        { label: '管理员', value: 1 },
      ],
      title: '操作',
      visible: false,
      confirmLoading: false,
      form: {},
      validatorRules: {
        name: [
          {
            required: true,
            message: '请输入角色名称',
            trigger: 'blur',
          },
          {
            min: 1,
            max: 100,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur',
          },
        ],
      },
      url: {
        add: 'role/addRole',
        edit: 'role/updteRole',
      },
    };
  },
  watch: {},
  computed: {},
  methods: {
    add() {
      // this.$refs.ref_menuTree.setCheckedKeys([]);
      this.edit({});
    },
    edit(record) {
      this.visible = true;
      this.form = { ...record };
      // 查询角色详情
      this.form.id &&
        getRoleAuthInfo(record.id).then((res) => {
          this.$nextTick(() => {
            this.$refs.ref_menuTree.setCheckedKeys(res.data);
          });
        });
    },
    close() {
      this.$refs.ref_menuTree.setCheckedKeys([]);
      this.$refs.form.resetFields();
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.$refs.form.validate((valid) => {
        if (valid) {
          that.confirmLoading = true;

          const checkedArry =
            this.$refs.ref_menuTree.getCheckedKeys(true) || [];
          if (checkedArry.length === 0) {
            this.$message.error('请选择菜单');
            return false;
          }

          let httpurl = '';
          let method = 'post';
          const params = {
            description: this.form.description,
            name: this.form.name,
            menus: checkedArry,
          };
          if (!this.form.id) {
            httpurl += this.url.add;
          } else {
            httpurl += this.url.edit;
            params.roleId = this.form.id;
          }
          // console.log(params)
          httpAction(httpurl, params, method)
            .then((res) => {
              if (res.code == 200) {
                that.$message.success('操作成功');
                that.$emit('ok');
              } else {
                that.$message.warning(res.msg || '操作失败');
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    getUserRoutes() {
      getUserRoutes2().then((res) => {
        this.menuTreeData = res.data;
      });
    },
  },
  created() {},
  mounted() {
    this.getUserRoutes();
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  .menuBar {
    border: 1px solid #dcdfe6;
    border-radius: 8px;
    /*height: calc(100% - 100px);*/
    height: 300px;
    overflow-y: auto;
  }
}
</style>
